<template>
  <el-dialog
    v-if="Object.keys(formDataObj).length > 0"
    class="propertyEditDialog"
    title="編輯產權資料"
    :visible.sync="visible"
    :before-close="beforeClose"
    @close="onClose"
  >
    <el-form
      ref="form"
      :rules="rules"
      :model="formDataObj"
      label-width="130px"
      :inline="true"
    >
      <el-form-item
        v-for="key in Object.keys(formStructureObj)"
        :key="key"
        :label="formStructureObj[key].label"
        :class="{isFull:formStructureObj[key].isFull}"
        :prop="key"
      >
        <el-input
          v-if="!key.match(/Tag|TabletNote|TotalArea|OwnershipRatio/)"
          v-model="formDataObj[key]"
          :type="key === 'Note' ? 'textarea' : 'text'"
          :rows="key === 'Note' ? 4 : 1"
          :maxlength="formStructureObj[key].maxLength"
          resize="none"
          @input="onInput(key, formDataObj)"
        />
        <div v-else>
          {{ key === 'TotalArea' ? sumArea: formDataObj[key] }}
        </div>
      </el-form-item>
      <el-form-item
        label="附加檔案"
        prop="anyFiles"
        class="isFull"
      >
        <template>
          <file
            v-model="inputFileList"
            type="any"
            name="any"
            :filearray="inputFileList"
            :quantity="10"
            @on-fileArray-change="onFileChanged"
          />
        </template>
      </el-form-item>
    </el-form>
    <el-button @click="beforeClose">
      取消
    </el-button>
    <el-button
      type="primary"
      :disabled="!isSubmittable"
      @click="handleSubmit"
    >
      送出
    </el-button>
  </el-dialog>
</template>

<script>
import { propertyStructure } from '../models'
import File from '../../../components/File'
import { imgFilenameExt } from '../../../js/models'

const notPureNumRegex = /[^0-9]/g
export default {
  components: {
    File
  },
  data () {
    const visible = false
    const formStructureObj = _cloneDeep(propertyStructure)
    delete formStructureObj.Id
    delete formStructureObj.OwnershipRatio
    // 編輯用的 obj
    const formDataObj = {}
    const isNumeric = (str) => {
      if (typeof str !== 'string' && typeof str !== 'number') return false // we only process strings!
      return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
        !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
    }
    const validateNumber = (rule, value, callback) => {
      if (isNumeric(value) || !value) {
        // 非必填可以輸入空值
        if (parseFloat(value) > 999.99) {
          callback(new Error('輸入數字大於上限，請重新輸入'))
        }
        if (parseFloat(value) < 0) {
          callback(new Error('面積數值不可為負'))
        }
        callback()
      }
      callback(new Error('請輸入數字'))
    }
    const pureNumRegex = /^[0-9]+$/
    const rules = {
      Address: [
        { required: true, message: '必填欄位不可為空', trigger: 'blur' },
        { max: 100, message: '限 100 個字元', trigger: 'blur' }
      ],
      PartArea: [
        { validator: validateNumber, trigger: 'blur' }
      ],
      ShareArea: [
        { validator: validateNumber, trigger: 'blur' }
      ],
      OwnershipHolderName: [
        { max: 10, message: '限 10 個字元', trigger: 'blur' }
      ],
      OwnershipHolderPhone: [
        { pattern: pureNumRegex, message: '請輸入數字', trigger: 'blur' },
        { max: 15, message: '限 15 個字元', trigger: 'blur' }
      ],
      Note: [
        { max: 50, message: '限 50 個字元', trigger: 'blur' }
      ]
    }
    const isSubmittable = true
    const originDataObj = null
    const selectedId = 0
    const inputFileList = []
    return {
      visible,
      formStructureObj,
      formDataObj,
      rules,
      isSubmittable,
      originDataObj,
      selectedId,
      inputFileList
    }
  },
  computed: {
    sumArea () {
      let sum = parseFloat(this.formDataObj.PartArea || 0) + parseFloat(this.formDataObj.ShareArea || 0)
      sum = sum.toFixed(2)
      sum = +sum
      sum = Number.isNaN(sum) ? 0 : sum
      return sum
    }
  },
  methods: {
    urlListToFileList (urlList) {
      return urlList.map(url => {
        const regex = new RegExp(imgFilenameExt.join('|'), 'i')
        const type = url.match(regex) ? 'img' : 'file'
        return {
          type,
          file: '',
          uploadUrl: url,
          BS64: ''
        }
      })
    },
    onClose () {
      this.$refs.form.clearValidate()
    },
    beforeClose () {
      if (JSON.stringify(this.originDataObj) !== JSON.stringify(this.formDataObj)) {
        this.$confirm('您修改的資料尚未儲存，仍要離開請按確定', {
          confirmButtonText: '確定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.visible = false
        }).catch(() => {})
      } else {
        this.visible = false
      }
    },
    scrollToErr () {
      this.$nextTick(() => {
        // 不管有沒有滑動相對於視窗就是這個數值
        const containerFixedY = document.querySelector('.propertyEditDialog .el-dialog__body').getBoundingClientRect().top
        // 滑動了多少
        const containerScrolledY = document.querySelector('.propertyEditDialog .el-dialog__body').scrollTop
        // 實際上 overflow 的頂端在這
        const containerOverflowY = containerFixedY - containerScrolledY
        // 實際上第一個錯誤的頂端
        const firstErrTop = document.querySelector('.propertyEditDialog .is-error').getBoundingClientRect().top
        const differ = firstErrTop - containerOverflowY
        document.querySelector('.propertyEditDialog .el-dialog__body').scrollTo(0, differ - 20)
      })
    },
    async handleSubmit () {
      this.$refs.form.validate(async (valid) => {
        const reqFormData = new FormData()
        for (const [key, val] of Object.entries(this.formDataObj)) {
          if (val && key !== 'Urls' && key !== 'TotalArea') {
            reqFormData.append(key, val)
          }
        }
        this.inputFileList.forEach(el => {
          if (el.file) {
            reqFormData.append('Files', el.file)
          }
          const url = el.uploadUrl
          if (url) {
            reqFormData.append('Urls', url)
          }
        })
        if (valid) {
          try {
            if (this.selectedId) {
              await apiHousehold.putPropertyById(this.selectedId, reqFormData)
              this.$message.success('產權資料編輯成功')
            } else {
              await apiHousehold.postPropertyById(reqFormData)
              this.$message.success('產權資料新增成功')
            }
            this.visible = false
            this.$emit('propertyDetailUpdated')
          } catch (error) {
            console.log(error)
          }
        } else {
          this.$message.error('請正確填寫產權資料')
          this.scrollToErr()
          return false
        }
      })
    },
    async setSelectedProperty (row) {
      try {
        this.selectedId = row.Id
        let data = {
          Tag: row.Tag,
          TabletNote: row.TabletNote,
          Address: null,
          PartArea: null,
          ShareArea: null,
          TotalArea: null,
          OwnershipHolderName: null,
          OwnershipHolderPhone: null,
          Note: null
        }
        if (this.selectedId) {
          const res = await apiHousehold.getPropertyById(this.selectedId)
          data = {
            ...data,
            ...res.data.Data.SingleHouseholdPropertys
          }
          if (data.Urls) {
            this.inputFileList = this.urlListToFileList(data.Urls)
          }
        }
        this.originDataObj = _cloneDeep(data)
        this.formDataObj = _cloneDeep(data)
        this.visible = true
      } catch (error) {
        console.log(error)
      }
    },
    onInput (key, obj) {
      if (['OwnershipHolderPhone'].includes(key)) {
        obj[key] = obj[key].replace(notPureNumRegex, '')
      }
      if (['PartArea', 'ShareArea'].includes(key)) {
        obj[key] = obj[key].replace(/[^0-9.]/g, '')
      }
    },
    onFileChanged (val) {
      this.inputFileList = val
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  @include basicDialog();
  max-height: 70vh;
  display: flex;
  flex-direction: column;
  width: 60%;
  .el-dialog__body {
    $title_height: 62px;
    height: calc(100% - #{$title_height});
    box-sizing: border-box;
    overflow-y: scroll;
  }
  .el-form .el-form-item {
    width: 50%;
    box-sizing: border-box;
    margin-right: 0 !important;
    text-align: start;
    display: flex;
    .el-form-item__content {
      flex-grow: 1;
    }
    .el-form-item__label {
      color: #333;
      font-weight: 700;
      font-size: 17px;
      margin-right: 0;
      flex: 0 0 130px;
    }
    .el-form-item__content {
      color: #666;
    }
    &.isFull {
      width: 100%;
    }
  }
}
</style>
